<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="transaction-error">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <div class="title">
            <h3>{{ title }}</h3>
          </div>
          <div
            class="msg"
            v-html="message"
          >
            <div>
              <a href="javascript:window.history.back()">Go Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'transaction-error',
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function() {
      return (this.error.title !== undefined) ? this.error.title : 'Transaction Payment Error'
    },
    message: function() {
      return (this.error.message !== undefined) ? this.error.message : 'An error occurred loading the transaction details for payment'
    }
  }
}
</script>

<style lang='scss' scoped>

  .transaction-error .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .transaction-error .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .transaction-error .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

  .transaction-error .title {
  }

</style>
